module.exports = __webpack_public_path__ + "img/thumbnail_StripedSkunk_f_erythristic.c46ad411.png";